import React from 'react';
import { Provider } from 'react-redux';
import { Route, Router, Switch } from 'react-router-dom';

import { history, store } from 'flow/configure-store';

import { setAdminLocation } from 'flow/components/admin-location';
import EmbedApplication from 'flow/routes/embed-application';
import ContextComponent from 'flow/route-components/ContextComponent';
import UserRegionProvider from 'flow/contexts/UserRegionProvider';
import { ModalProvider } from 'flow/contexts/ModalProvider';

const getRoutes = () => {
    return (
        <Provider store={store}>
            <ModalProvider>
                <UserRegionProvider>
                    <Router history={history}>
                        <Switch>
                            <Route
                                path="/embed/:type/*"
                                component={EmbedApplication}
                            />
                            <Route
                                path="/embed/:type"
                                component={EmbedApplication}
                            />
                            <Route
                                component={setAdminLocation(ContextComponent)}
                            />
                            <Route path="*" component={PageNotFound} />
                        </Switch>
                    </Router>
                </UserRegionProvider>
            </ModalProvider>
        </Provider>
    );
};

class PageNotFound extends React.PureComponent {
    render() {
        return <div>{'Page not found'}</div>;
    }
}

export default getRoutes;
